import { useEffect, useState } from 'react'
import { useAuth } from '../../context/AuthContext.jsx'
import { useApp } from '../../context/AppContext.jsx'
import { fetchApi } from '../../db/api.js'
import { profileAccountDetails } from '../../lib/profileAccountDetails.js'
import Icon from '../../components/icons.jsx'
import './profile-account-details.css'

export default function ProfileAccountDetails() {
  const { user } = useAuth()
  const { memberships, activeOrganizationId, selectedClient } = useApp()
  const [result, setResult] = useState(null)
  useEffect(() => {
    if (!user?.id) return
    let active = true
    fetchApi('/me/profile')
      .then((data) => { if (active) setResult({ userId: user.id, profile: data, error: false }) })
      .catch(() => { if (active) setResult({ userId: user.id, error: true }) })
    return () => { active = false }
  }, [user?.id])
  const current = result?.userId === user?.id ? result : null
  const fields = profileAccountDetails({ user, profile: current?.profile, memberships, activeOrganizationId, selectedClient })
  if (!current && !fields.phone) fields.phone = 'Carregando…'
  if (current?.error && !fields.phone) fields.phone = 'Não foi possível carregar'
  return <section className="mp-card profile-account-details" aria-labelledby="profile-account-title">
    <div className="mp-section-heading">
      <span className="mp-section-icon"><Icon n="briefcase" s={17} /></span>
      <div><h2 id="profile-account-title">Dados da conta</h2><p>Seu vínculo com a organização.</p></div>
    </div>
    <dl>
      <div><dt>Organização</dt><dd>{fields.organization}</dd></div>
      <div><dt>Perfil de acesso <small>{fields.roleScope}</small></dt><dd><span className="mp-access-badge">{fields.role}</span></dd></div>
      <div><dt>Telefone</dt><dd className={!fields.phone ? 'mp-empty-value' : undefined}>{fields.phone || 'Não informado'}</dd></div>
      <div><dt>{fields.dateLabel}</dt><dd>{fields.date}</dd></div>
    </dl>
  </section>
}
